// Cliente centralizado para chamadas da API backend
const INTERNAL_TOKEN = process.env.REACT_APP_INTERNAL_TOKEN || '3d1cc354289cbfadc1ed36cddb64d161';

// Base da API do backend (busca do Instagram, limite, tracking).
// Configure REACT_APP_API_URL no .env (ex.: https://api.pinkstalker.site). Vazio = mesma origem,
// e o server.js faz proxy de /api para o backend. Em localhost sem variável, usa http://localhost:8080.
export function getApiBaseUrl() {
  const configured = (process.env.REACT_APP_API_URL || '').trim().replace(/[/]+$/, '');
  if (configured) return configured;
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location?.hostname === 'localhost' || window.location?.hostname === '127.0.0.1');
  return isLocalhost ? 'http://localhost:8080' : '';
}

class ApiClient {
  constructor() {
    this.token = INTERNAL_TOKEN;
  }

  get baseUrl() {
    return getApiBaseUrl();
  }

  // Headers padrão com token interno
  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'X-Internal-Token': this.token
    };
  }

  // Buscar perfil do Instagram via backend (Parseium)
  async getInstagramProfile(username) {
    try {
      console.log('[API Client] Buscando perfil do Instagram:', username);
      
      const url = `${this.baseUrl}/api/instagram/profile?username=${encodeURIComponent(username)}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: this.getHeaders()
      });
      
      const text = await response.text();
      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json') || text.trim().startsWith('<')) {
        console.error('[API Client] Resposta não é JSON. Verifique se o proxy /api está ativo.');
        return {
          success: false,
          source: 'parseium',
          message: 'Serviço temporariamente indisponível. Tente novamente.',
          profile: null
        };
      }
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error('[API Client] Resposta inválida:', e);
        return {
          success: false,
          source: 'parseium',
          message: 'Erro de conexão com o servidor',
          profile: null
        };
      }
      
      if (!response.ok) {
        console.error('[API Client] Erro na resposta:', data);
        return {
          success: false,
          source: 'parseium',
          message: data.error || data.message || 'Erro ao buscar perfil',
          profile: null
        };
      }
      
      console.log('[API Client] Perfil recebido:', username);
      return data;
      
    } catch (error) {
      console.error('[API Client] Erro na requisição:', error);
      return {
        success: false,
        source: 'parseium',
        message: 'Erro de conexão com o servidor',
        profile: null
      };
    }
  }

  // Limite de 1 pesquisa por dispositivo (rotas públicas, sem token).
  // Em erro (rede, timeout, !response.ok) rejeita a Promise para o Home não liberar a busca.
  async checkSearchLimit(fingerprint) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(`${this.baseUrl}/api/limit/check-search`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fingerprint }),
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      const text = await response.text();
      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json') || text.trim().startsWith('<')) {
        console.warn('[API Client] checkSearchLimit: resposta não é JSON (404 ou HTML). Verifique REACT_APP_API_URL em produção.');
        throw new Error('Serviço de limite indisponível');
      }
      const data = JSON.parse(text);
      if (!response.ok) {
        throw new Error(data.error || 'Erro ao verificar limite');
      }
      return data;
    } catch (error) {
      clearTimeout(timeoutId);
      console.warn('[API Client] checkSearchLimit:', error);
      throw error;
    }
  }

  async useFreeSearch(fingerprint, username, profileData) {
    try {
      const response = await fetch(`${this.baseUrl}/api/limit/use-free-search`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fingerprint, username, profileData })
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        console.warn('[API Client] useFreeSearch:', err);
        return { ok: false };
      }
      return await response.json();
    } catch (error) {
      console.warn('[API Client] useFreeSearch:', error);
      return { ok: false };
    }
  }
}

const apiClient = new ApiClient();
export default apiClient;
